import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box} from '@mui/material'
import {NatApplicationRepo} from '../../repository/NatApplicationRepo'
import {BlockSpacer, currentMedia, GridContainer, GridItem} from '../../../../../styledComponents/ResponsiveConvenience'
import {FlexContainer, FullWidthColumnFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import NatCurrentDateTimeRepo from '../../../currentDateTime/repository/NatCurrentDateTimeRepo'
import moment from 'moment'
import {CHANGE_TYPE, USER_ATTRIBUTE} from '../../../../../CodeMaster'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey,
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import PPDatePickerForResident from '../../../../../components/shared/forms/resident/PPDatePickerForResident'
import {ApplyButton, ItemHeading, WideWhiteArea} from '../../common/resident/NatResidentApplicationsCommon'
import {NatGetCurrentDateTime} from '../../../currentDateTime/repository/NatGetCurrentDateTime'
import {NatResidentBikeParkingUseChangeApplyLocationState} from '../NatResidentApplicationInterface'
import {Nullable} from '../../../../../app/TypeHelpers'
import EventEmitterExResident from '../../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import NatCondominiumRepo from '../../../condominium/repository/NatCondominiumRepo'
import PPRadioGroupForResident from '../../../../../components/shared/forms/resident/PPRadioGroupForResident'
import {HKConstants} from '../../../../../HKConstants'
import NatResidentApplicationDetailFormItem from '../../common/resident/NatResidentApplicationDetailFormItem'
import HolidaysRepository from '../../../../../components/HolidaysRepository'
import {AsyncCallFunctionType} from '../../../../../components/shared/hoc/withAsyncCommunication'
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident'
import {StyledDiv} from '../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import ErrorMessageAreaWrapper from '../../../../../components/shared/forms/resident/ErrorMessageAreaWrapper'
import {NatPutBikeParkingUseChangeApplyRequest} from '../../repository/NatPutBikeParkingUseChangeApply'
import {DisplayItemInputTitleRequiredNoMargin} from '../../../../../styledComponents/DisplayItem'
import {Location, NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    condominiumRepo: NatCondominiumRepo
    holidaysRepo: HolidaysRepository
    navigate: NavigateFunction
    location: Location<NatResidentBikeParkingUseChangeApplyLocationState>
    eventEmitter: EventEmitterExResident
    asyncCallFunction: AsyncCallFunctionType

    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    useArea: Nullable<string>
    changeType: Nullable<string>
    changeStartDate: Nullable<string>
    changeEndDate: Nullable<string>
    userFamilyName: Nullable<string>
    userFirstName: Nullable<string>
    userAttribute: Nullable<string>
    ownerFamilyName: Nullable<string>
    ownerFirstName: Nullable<string>
    bikeType: Nullable<string>
    bikeName: Nullable<string>
    bikeRegistrationNumber: Nullable<string>
    engineSize: Nullable<string>

    submitButtonLabel: string
    onClickApplyConfirmButton: (request: NatPutBikeParkingUseChangeApplyRequest) => Promise<void>
}

interface State {
    applicantFamilyName: string
    applicantFirstName: string
    useArea: string
    changeType: string
    changeStartDate: string
    changeEndDate: string
    userFamilyName: string
    userFirstName: string
    userAttribute: string
    ownerFamilyName: string
    ownerFirstName: string
    bikeType: string
    bikeName: string
    bikeRegistrationNumber: string
    engineSize: string

    currentDate: moment.Moment
    holidays: string[]

    applyButtonDisabled: boolean
    isLoadCompleted: boolean
}

export default class NatResidentBikeParkingUseChangeApplyForm extends Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            applyButtonDisabled: true,
            applicantFamilyName: '',
            applicantFirstName: '',
            useArea: '',
            changeType: '',
            changeStartDate: '',
            changeEndDate: '',
            userFamilyName: '',
            userFirstName: '',
            userAttribute: '',
            ownerFamilyName: '',
            ownerFirstName: '',
            bikeType: '',
            bikeName: '',
            bikeRegistrationNumber: '',
            engineSize: '',
            currentDate: moment(),
            holidays: [],
            isLoadCompleted: false
        }

        this.handleChangeChangeType = this.handleChangeChangeType.bind(this)
        this.handleChangeChangeStartDate = this.handleChangeChangeStartDate.bind(this)
        this.handleChangeChangeEndDate = this.handleChangeChangeEndDate.bind(this)
        this.handleChangeUserAttribute = this.handleChangeUserAttribute.bind(this)
        this.handleChangeText = this.handleChangeText.bind(this)
        this.onClickApplyConfirmButton = this.onClickApplyConfirmButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const [currentTimeResponse, holidays] = await Promise.all([
                this.getCurrentDateTime(),
                this.getHoliday(),
            ])

            if (currentTimeResponse && currentTimeResponse.details) {
                this.setState({
                    currentDate: moment(currentTimeResponse.details.currentDateTime)
                })
            }

            const applicantFamilyName = this.props.applicantFamilyName ?? this.state.applicantFamilyName
            const applicantFirstName = this.props.applicantFirstName ?? this.state.applicantFirstName
            const useArea = this.props.useArea ?? this.state.useArea
            const changeType = this.props.changeType ?? this.state.changeType
            const changeStartDate = this.props.changeStartDate ?? this.state.changeStartDate
            const changeEndDate = this.props.changeEndDate ?? this.state.changeEndDate
            const userFamilyName = this.props.userFamilyName ?? this.state.userFamilyName
            const userFirstName = this.props.userFirstName ?? this.state.userFirstName
            const userAttribute = this.props.userAttribute ?? this.state.userAttribute
            const ownerFamilyName = this.props.ownerFamilyName ?? this.state.ownerFamilyName
            const ownerFirstName = this.props.ownerFirstName ?? this.state.ownerFirstName
            const bikeType = this.props.bikeType ?? this.state.bikeType
            const bikeName = this.props.bikeName ?? this.state.bikeName
            const bikeRegistrationNumber = this.props.bikeRegistrationNumber ?? this.state.bikeRegistrationNumber
            const engineSize = this.props.engineSize ?? this.state.engineSize

            this.setState({
                applicantFamilyName: applicantFamilyName,
                applicantFirstName: applicantFirstName,
                useArea: useArea,
                changeType: changeType,
                changeStartDate: changeStartDate,
                changeEndDate: changeEndDate,
                userFamilyName: userFamilyName,
                userFirstName: userFirstName,
                userAttribute: userAttribute,
                ownerFamilyName: ownerFamilyName,
                ownerFirstName: ownerFirstName,
                bikeType: bikeType,
                bikeName: bikeName,
                bikeRegistrationNumber: bikeRegistrationNumber,
                engineSize: engineSize,
                holidays: holidays === null ? [] : holidays
            }, () => {
                this.updateApplyConfirmButtonDisabled()
            })
        } finally {
            this.setState({isLoadCompleted: true})
            this.props.eventEmitter.closeLoading()
        }
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {currentDateTimeRepo, eventEmitter} = this.props

        return await this.props.asyncCallFunction(
            currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    async getHoliday(): Promise<Nullable<string[]>> {
        const {holidaysRepo, eventEmitter} = this.props

        const minDate: string = HKConstants.CMN.SYC.MIN_HOLIDAY_DATE
        const maxDate: string = HKConstants.CMN.SYC.MAX_HOLIDAY_DATE
        return await this.props.asyncCallFunction(
            holidaysRepo.getHolidays.bind(holidaysRepo, minDate, maxDate),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeChangeStartDate(date: string): void {
        this.setState({changeStartDate: date}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeChangeEndDate(date: string): void {
        this.setState({changeEndDate: date}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeUserAttribute(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            userAttribute: event.target.value
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeChangeType(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            changeType: event.target.value
        }, () => {
            this.updateInitChangeEndDate()
            this.updateApplyConfirmButtonDisabled()
        })
    }

    updateInitChangeEndDate(): void {
        if (this.state.changeType === CHANGE_TYPE.PERMANENT.value) {
            this.setState({changeEndDate: ''})
        }
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            applicantFamilyName, applicantFirstName, useArea, changeType,
            changeStartDate, changeEndDate, userFamilyName, userFirstName, userAttribute,
            ownerFamilyName, ownerFirstName, bikeType, bikeName, bikeRegistrationNumber,
            engineSize
        } = this.state

        let applyButtonDisabled = false

        if (!applicantFamilyName || !applicantFirstName || !useArea || !changeType ||
            !changeStartDate || !userFamilyName || !userFirstName ||
            !userAttribute || !ownerFamilyName || !ownerFirstName ||
            !bikeType || !bikeName || !bikeRegistrationNumber || !engineSize) {
            applyButtonDisabled = true
        }

        if (this.state.changeType === CHANGE_TYPE.TEMPORARY.value) {
            if (!changeEndDate) {
                applyButtonDisabled = true
            }
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    async onClickApplyConfirmButton(): Promise<void> {
        const {
            applicantFamilyName, applicantFirstName, useArea, changeType,
            changeStartDate, changeEndDate, userFamilyName, userFirstName, userAttribute,
            ownerFamilyName, ownerFirstName, bikeType, bikeName, bikeRegistrationNumber,
            engineSize
        } = this.state

        const request = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            useArea: useArea,
            changeType: changeType,
            changeStartDate: changeStartDate,
            changeEndDate: changeEndDate,
            userFamilyName: userFamilyName,
            userFirstName: userFirstName,
            userAttribute: userAttribute,
            ownerFamilyName: ownerFamilyName,
            ownerFirstName: ownerFirstName,
            bikeType: bikeType,
            bikeName: bikeName,
            bikeRegistrationNumber: bikeRegistrationNumber,
            engineSize: engineSize,
            confirmed: false
        }

        if (!request) {
            return
        }
        await this.props.onClickApplyConfirmButton(request)
    }

    renderApplicantForm(): ReactElement {
        const {applicantFamilyName, applicantFirstName} = this.state

        const applicantRoom = NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
            convertToRoomNumberForResident(
                NatResidentLoginInfoSessionStorageHelper
                    .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
            )

        return (
            <>
                <ItemHeading>
                    申請者
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    {applicantRoom}
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFamilyName',
                                        maxLength: 10,
                                        value: applicantFamilyName,
                                        onChange: this.handleChangeText,
                                        placeholder: '例：素敵'
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFirstName',
                                        maxLength: 10,
                                        value: applicantFirstName,
                                        placeholder: '例：太郎'
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderUseAreaForm(): ReactElement {
        const {useArea} = this.state

        return (
            <>
                <ItemHeading>
                    使用区画
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>現在契約中の<BreakPcOnly/>バイク置場の区画番号</span>}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    maxLength: 20,
                                    name: 'useArea',
                                    value: useArea
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['useArea']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderChangeTypeForm(): ReactElement {
        const {changeType} = this.state

        return (
            <>
                <ItemHeading>
                    変更態様
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <DisplayItemInputTitleRequiredNoMargin>
                        駐車するバイクの変更態様
                    </DisplayItemInputTitleRequiredNoMargin>
                    <Box height={'20px'}/>
                    <GridContainer>
                        <GridItem over={12}>
                            <PPRadioGroupForResident
                                data={CHANGE_TYPE.values()}
                                selectValue={changeType}
                                onChange={this.handleChangeChangeType}
                                eventKeys={['changeType']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </GridItem>
                    </GridContainer>
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderChangeDateForm(): ReactElement {
        const {changeStartDate, changeEndDate, currentDate, holidays} = this.state
        const  maxOfStartDate = changeEndDate ? new Date(changeEndDate) : null
        const  minOfEndDate = changeStartDate ? new Date(changeStartDate) : null

        return (
            <>
                <ItemHeading>
                    変更日
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>開始日</span>}
                        required
                        component={
                            <PPDatePickerForResident
                                date={changeStartDate}
                                onChange={this.handleChangeChangeStartDate}
                                holidays={holidays}
                                itemValue={''}
                                eventKeys={['changeStartDate']}
                                eventEmitter={this.props.eventEmitter}
                                today={currentDate.toDate()}
                                maxDate={maxOfStartDate}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    {(this.state.changeType === CHANGE_TYPE.TEMPORARY.value) &&
                        <>
                            <NatResidentApplicationDetailFormItem
                                title={<span>終了日</span>}
                                required
                                component={
                                    <PPDatePickerForResident
                                        date={changeEndDate}
                                        onChange={this.handleChangeChangeEndDate}
                                        holidays={holidays}
                                        itemValue={''}
                                        eventKeys={['changeEndDate']}
                                        eventEmitter={this.props.eventEmitter}
                                        minDate={minOfEndDate}
                                    />
                                }
                            />
                            <Box height={'20px'}/>
                        </>
                    }
                </WideWhiteArea>
            </>
        )
    }

    renderRentUserForm(): ReactElement {
        const {userFamilyName, userFirstName, userAttribute} = this.state

        return (
            <>
                <ItemHeading>
                    使用者（実際にバイク置場を使用される方）
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'使用者氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'userFamilyName',
                                        value: userFamilyName,
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['userFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'userFirstName',
                                        value: userFirstName,
                                        placeholder: '例：太郎',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['userFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'属性'}
                        required
                        component={
                            <GridContainer>
                                <GridItem over={12}>
                                    <PPRadioGroupForResident
                                        data={USER_ATTRIBUTE.values()}
                                        selectValue={userAttribute}
                                        onChange={this.handleChangeUserAttribute}
                                        eventKeys={['userAttribute']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </GridItem>
                            </GridContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderRentBikeInfoForm(): ReactElement {
        const {ownerFamilyName, ownerFirstName, bikeType, bikeName, bikeRegistrationNumber, engineSize} = this.state

        return (
            <>
                <ItemHeading>
                    変更後のバイク情報（自動車検査証参照）
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'所有者氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'ownerFamilyName',
                                        value: ownerFamilyName,
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['ownerFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 10,
                                        name: 'ownerFirstName',
                                        value: ownerFirstName,
                                        placeholder: '例：太郎',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['ownerFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'種別'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 20,
                                        name: 'bikeType',
                                        value: bikeType,
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['bikeType']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'車名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 100,
                                        name: 'bikeName',
                                        value: bikeName,
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['bikeName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'標識番号または車両番号'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 20,
                                        name: 'bikeRegistrationNumber',
                                        value: bikeRegistrationNumber,
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['bikeRegistrationNumber']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'排気量'}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <UnitTextBoxArea>
                                    <PPTextFieldForResident
                                        inputProps={{
                                            maxLength: 4,
                                            name: 'engineSize',
                                            value: engineSize,
                                            placeholder: '半角数字で入力してください',
                                            inputMode: 'numeric'
                                        }}
                                        onChange={this.handleChangeText}
                                        eventKeys={['engineSize']}
                                        eventEmitter={this.props.eventEmitter}
                                        unitText={'cc'}
                                    />
                                </UnitTextBoxArea>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    render(): ReactElement {
        const {submitButtonLabel} = this.props
        const {applyButtonDisabled} = this.state

        if (!this.state.isLoadCompleted) {
            return (<></>)
        }

        return (
            <>
                {this.renderApplicantForm()}
                < Box height={'15px'}/>
                {this.renderUseAreaForm()}
                <Box height={'15px'}/>
                {this.renderChangeTypeForm()}
                <Box height={'15px'}/>
                {(this.state.changeType !== '') &&
                    <>
                        {this.renderChangeDateForm()}
                        < Box height={'15px'}/>
                    </>
                }
                {this.renderRentUserForm()}
                <Box height={'15px'}/>
                {this.renderRentBikeInfoForm()}
                <ApplyButton disabled={applyButtonDisabled} onClick={this.onClickApplyConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            {submitButtonLabel}
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

const BreakPcOnly = styled('br')`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`
const UnitTextBoxArea: StyledDiv = styled.div`
  ${currentMedia.greaterThan('pc')`
    max-width: 335px;
  `};
`
